import { render, staticRenderFns } from "./ownermanagement.vue?vue&type=template&id=50e5336a&scoped=true"
import script from "./ownermanagement.vue?vue&type=script&lang=js"
export * from "./ownermanagement.vue?vue&type=script&lang=js"
import style0 from "./ownermanagement.vue?vue&type=style&index=0&id=50e5336a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e5336a",
  null
  
)

export default component.exports